import { action } from 'satcheljs';
import { Model } from '../../../../@data';
import { IGridQuery } from '../../GridV2.types';

export const onGridPageV2Initialized = action(
  'onGridPageV2Initialized',
  (data: Model[], entity: new () => Model, query?: IGridQuery<Model>) => ({ data, entity, query })
);
